"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var react_1 = __importStar(require("react"));
var Label_module_css_1 = __importDefault(require("./Label.module.css"));
var Label = (function (_super) {
    __extends(Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Label.prototype.render = function () {
        var _a = this.props, children = _a.children, text = _a.text, error = _a.error, required = _a.required, _b = _a.className, className = _b === void 0 ? "" : _b, backendErrors = _a.backendErrors;
        return (react_1.default.createElement("label", { className: "".concat(Label_module_css_1.default.root, " ").concat(className) },
            text && (react_1.default.createElement("p", { className: Label_module_css_1.default.text },
                text,
                required && react_1.default.createElement("span", { className: Label_module_css_1.default.required }, " *"))),
            children,
            error && (react_1.default.createElement("div", { className: Label_module_css_1.default.errorWrapper },
                react_1.default.createElement("p", { className: Label_module_css_1.default.errorText }, error))),
            backendErrors && (react_1.default.createElement("div", { className: Label_module_css_1.default.errorWrapper },
                react_1.default.createElement("p", { className: Label_module_css_1.default.errorText }, backendErrors)))));
    };
    return Label;
}(react_1.Component));
exports.Label = Label;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGFiZWwuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0NhcHRjaGEvTGFiZWwvTGFiZWwudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXNDO0FBQ3RDLHdFQUF1QztBQVd2QztJQUEyQix5QkFBb0I7SUFBL0M7O0lBeUJBLENBQUM7SUF4QlUsc0JBQU0sR0FBYjtRQUNVLElBQUEsS0FBbUUsSUFBSSxDQUFDLEtBQUssRUFBNUUsUUFBUSxjQUFBLEVBQUUsSUFBSSxVQUFBLEVBQUUsS0FBSyxXQUFBLEVBQUUsUUFBUSxjQUFBLEVBQUUsaUJBQWMsRUFBZCxTQUFTLG1CQUFHLEVBQUUsS0FBQSxFQUFFLGFBQWEsbUJBQWMsQ0FBQTtRQUNuRixPQUFPLENBQ0gseUNBQU8sU0FBUyxFQUFFLFVBQUcsMEJBQU0sQ0FBQyxJQUFJLGNBQUksU0FBUyxDQUFFO1lBQzFDLElBQUksSUFBSSxDQUNMLHFDQUFHLFNBQVMsRUFBRSwwQkFBTSxDQUFDLElBQUk7Z0JBQ3BCLElBQUk7Z0JBQ0osUUFBUSxJQUFJLHdDQUFNLFNBQVMsRUFBRSwwQkFBTSxDQUFDLFFBQVEsU0FBVyxDQUN4RCxDQUNQO1lBQ0EsUUFBUTtZQUNSLEtBQUssSUFBSSxDQUNOLHVDQUFLLFNBQVMsRUFBRSwwQkFBTSxDQUFDLFlBQVk7Z0JBQy9CLHFDQUFHLFNBQVMsRUFBRSwwQkFBTSxDQUFDLFNBQVMsSUFBRyxLQUFLLENBQUssQ0FDekMsQ0FDVDtZQUNBLGFBQWEsSUFBSSxDQUNkLHVDQUFLLFNBQVMsRUFBRSwwQkFBTSxDQUFDLFlBQVk7Z0JBQy9CLHFDQUFHLFNBQVMsRUFBRSwwQkFBTSxDQUFDLFNBQVMsSUFBRyxhQUFhLENBQUssQ0FDakQsQ0FDVCxDQUNHLENBQ1gsQ0FBQTtJQUNMLENBQUM7SUFDTCxZQUFDO0FBQUQsQ0FBQyxBQXpCRCxDQUEyQixpQkFBUyxHQXlCbkM7QUF6Qlksc0JBQUsifQ==